(function () {
  /* Re-runnable so the product section re-initialises when the Theme Editor
     re-renders it (shopify:section:load). On the storefront this runs exactly
     once — identical to before. The one portaled element (the body-level buy
     bar) is cleared first so a re-render can't leave a duplicate behind. */
  function initProduct() {
    var staleBuybar = document.querySelector('.buybar');
    if (staleBuybar) staleBuybar.remove();
    var main = document.querySelector('.product');
  var title = (main && main.getAttribute('data-product-title')) || '';
  var price = (main && main.getAttribute('data-price')) || '';
  var compare = (main && main.getAttribute('data-compare')) || '';
  var curSize = (main && main.getAttribute('data-current-size')) || '';
  /* Liquid-resolved CTA label — carries the pre-order wording („Užsakyti iš
     anksto") when the product is tagged `netrukus`; falls back to the
     registry default for safety. */
  var atcLabel = (main && main.getAttribute('data-atc-label')) || theme.t('product.add_to_cart');

  /* ── sticky buy bar (JS-generated), fed with real product title + price ── */
  var buybar = document.createElement('div');
  buybar.className = 'buybar';
  var priceHtml = price + (compare ? ' <s style="opacity:.55">' + compare + '</s>' : '');
  buybar.innerHTML =
    '<div class="buybar__meta">' +
      '<span class="buybar__name"></span>' +
      '<span class="buybar__price"></span>' +
    '</div>' +
    '<span class="buybar__size" data-buybar-size></span>' +
    '<button class="btn btn--primary" type="button" data-buybar-add style="white-space:nowrap;"><span></span></button>';
  /* Docked into the header's slot (sections/header.liquid) rather than <body>:
     the sticky header already positions correctly on iOS, so the bar inherits
     that instead of computing a viewport offset of its own. If the slot is ever
     missing the bar simply stays detached — every reference below still
     resolves, so nothing throws and a half-positioned bar never ships. */
  var dock = document.querySelector('[data-buybar-dock]');
  if (dock) dock.appendChild(buybar);
  buybar.querySelector('.buybar__name').textContent = title;
  buybar.querySelector('.buybar__price').innerHTML = priceHtml;
  buybar.querySelector('[data-buybar-add] span').textContent = atcLabel;
  var buybarSize = buybar.querySelector('[data-buybar-size]');
  if (buybarSize) buybarSize.textContent = curSize ? 'EU ' + curSize : '';

  var ctas = document.querySelector('.ctas');
  if (ctas && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      // show only after the CTA block has scrolled ABOVE the viewport
      buybar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(ctas);
  }

  /* ── commerce wiring ── */
  var form = document.querySelector('.product form[action*="/cart/add"]') || document.querySelector('.product form');
  var idInput = document.querySelector('[data-product-id]') || (form && form.querySelector('[name="id"]'));
  var atc = document.querySelector('[data-atc]');
  var priceCurrent = document.querySelector('.price__current');
  var priceStrike = document.querySelector('.price__strike');

  /* size selection */
  document.querySelectorAll('.size').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.hasAttribute('disabled')) return;

      /* Sold out: say so instead of swallowing the tap, and leave the current
         selection (and the CTA) exactly as it was. */
      if (btn.getAttribute('aria-disabled') === 'true') {
        var soldNote = document.querySelector('[data-sizes-note]');
        if (soldNote) {
          var soldEu = btn.querySelector('.size__eu');
          soldNote.textContent = theme.t('product.size_sold_out', {
            size: soldEu ? soldEu.textContent.trim() : btn.textContent.trim()
          });
          soldNote.hidden = false;
        }
        return;
      }

      document.querySelectorAll('.size').forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-checked', 'true');

      var eu = btn.querySelector('.size__eu');
      var label = eu ? eu.textContent.trim() : btn.textContent.trim();
      if (buybarSize) buybarSize.textContent = 'EU ' + label;

      var note = document.querySelector('[data-sizes-note]');
      if (note) {
        var qty = parseInt(btn.getAttribute('data-variant-qty'), 10);
        if (qty > 0 && qty <= 5) { note.textContent = theme.t('product.stock_left', { count: qty }); note.hidden = false; }
        else { note.hidden = true; }
      }

      var vid = btn.getAttribute('data-variant-id');
      if (vid && idInput) idInput.value = vid;

      /* first pick unlocks the CTA (rendered disabled with „Pasirinkite dydį")
         and reveals express checkout, which buys the form's variant directly */
      if (atc && atc.hasAttribute('data-locked')) {
        atc.removeAttribute('data-locked');
        atc.disabled = false;
        atc.classList.remove('is-locked');
        var atcSpan = atc.querySelector('span');
        if (atcSpan) atcSpan.textContent = atcLabel;
        var express = document.querySelector('.ctas__express');
        if (express) express.hidden = false;
      }

      var vp = btn.getAttribute('data-variant-price');
      var vc = btn.getAttribute('data-variant-compare');
      if (vp && priceCurrent) priceCurrent.textContent = vp;
      if (priceStrike) {
        if (vc) { priceStrike.textContent = vc; priceStrike.style.display = ''; }
        else { priceStrike.style.display = 'none'; }
      }
      var bp = buybar.querySelector('.buybar__price');
      if (bp) bp.innerHTML = (vp || price) + (vc ? ' <s style="opacity:.55">' + vc + '</s>' : '');
    });
  });

  /* success UI on an add button */
  function added(btn) {
    if (!btn) return;
    var span = btn.querySelector('span');
    var arrow = btn.querySelector('.btn__arrow');
    if (!span) return;
    var orig = span.textContent;
    span.textContent = theme.t('product.added_short');
    if (arrow) arrow.style.display = 'none';
    setTimeout(function () {
      span.textContent = orig;
      if (arrow) arrow.style.display = '';
    }, 1400);
  }

  /* aria-live status region: announces success, shows errors visibly.
     Visually hidden by default; .is-error makes it a visible inline message. */
  var atcStatus = document.createElement('div');
  atcStatus.className = 'atc-status';
  atcStatus.setAttribute('role', 'status');
  atcStatus.setAttribute('aria-live', 'assertive');
  (function () {
    var host = document.querySelector('.ctas');
    if (host && host.parentNode) { host.parentNode.insertBefore(atcStatus, host.nextSibling); }
    else { document.body.appendChild(atcStatus); }
  })();

  /* real Shopify Cart AJAX add — guarded against double-clicks, surfaces errors */
  var adding = false;
  function addToCart(btn) {
    var id = idInput && idInput.value;
    if (!id || adding) return;
    adding = true;
    if (btn) btn.disabled = true;
    atcStatus.textContent = '';
    atcStatus.classList.remove('is-error');
    /* The payload is hand-built (not FormData), so the pre-order deposit
       plan — a hidden [name="selling_plan"] in the form — must be carried
       over explicitly or checkout silently charges full price. */
    var item = { id: id, quantity: 1 };
    var planInput = form && form.querySelector('[name="selling_plan"]');
    if (planInput && planInput.value) item.selling_plan = planInput.value;
    theme.cart.add([item])
      .then(function () {
        added(btn);
        atcStatus.textContent = theme.t('product.added_to_cart');
      })
      .catch(function (err) {
        atcStatus.textContent = (err && err.userMessage) || theme.t('product.add_error');
        atcStatus.classList.add('is-error');
      })
      .then(function () {
        adding = false;
        if (btn) btn.disabled = false;
      });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(atc || form.querySelector('[type="submit"]'));
    });
  } else if (atc) {
    atc.addEventListener('click', function () { addToCart(atc); });
  }
  var buybarAdd = buybar.querySelector('[data-buybar-add]');
  if (buybarAdd) buybarAdd.addEventListener('click', function () {
    /* no size picked yet → walk the shopper to the size grid instead of a dead add */
    if (atc && atc.hasAttribute('data-locked')) {
      var sizes = document.querySelector('.sizes[role="radiogroup"]');
      if (sizes) sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    addToCart(buybarAdd);
  });

  /* size radiogroup: roving tabindex + arrow-key navigation (WAI-ARIA APG) */
  (function () {
    var group = document.querySelector('.sizes[role="radiogroup"]');
    if (!group) return;
    var radios = Array.prototype.slice.call(group.querySelectorAll('[role="radio"]'));
    var enabled = radios.filter(function (r) { return !r.disabled; });
    if (!enabled.length) return;
    function setTabStops() {
      var stop = enabled.filter(function (r) {
        return r.getAttribute('aria-checked') === 'true';
      })[0] || enabled[0];
      radios.forEach(function (r) { r.tabIndex = (r === stop) ? 0 : -1; });
    }
    setTabStops();
    group.addEventListener('keydown', function (e) {
      var cur = document.activeElement;
      var i = enabled.indexOf(cur);
      if (i === -1) return;
      var next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = enabled[(i + 1) % enabled.length]; }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { next = enabled[(i - 1 + enabled.length) % enabled.length]; }
      else if (e.key === 'Home') { next = enabled[0]; }
      else if (e.key === 'End') { next = enabled[enabled.length - 1]; }
      else { return; }
      e.preventDefault();
      next.click();
      setTabStops();
      next.focus();
    });
    group.addEventListener('click', setTabStops);
  })();

  /* mobile gallery carousel — sync pagination dots */
  (function () {
    var gallery = document.querySelector('.gallery');
    var dots = Array.prototype.slice.call(document.querySelectorAll('.gallery-dots button'));
    if (!gallery || !dots.length) return;
    var shots = gallery.querySelectorAll('.shot');
    var raf;
    function sync() {
      var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
      i = Math.max(0, Math.min(dots.length - 1, i));
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    gallery.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () {
        if (shots[n]) gallery.scrollTo({ left: n * gallery.clientWidth, behavior: 'smooth' });
      });
    });
  })();

  /* tap-to-zoom — the photo AND the magnifier open the lightbox.
     Both were dead: .shot__zoom shipped styled and labelled but was never bound
     to anything, and the image was inert, so every tap on either was a no-op.
     Clarity caught it on four products in three days (the button logs as blank
     text because it holds only an icon; the image logs its "— vaizdas N" alt).
     Delegated from .gallery so it survives the carousel's re-render, and
     flagged so a header-only section reload cannot bind it twice. */
  (function () {
    var gallery = document.querySelector('.gallery');
    var zoom = document.getElementById('productZoom');
    if (!gallery || !zoom || gallery.dataset.zoomWired) return;
    gallery.dataset.zoomWired = '1';
    var big = zoom.querySelector('.zoom__img');
    var frame = zoom.querySelector('.zoom__frame');

    gallery.addEventListener('click', function (e) {
      /* Videos and embeds keep their own controls — only still images zoom. */
      var hit = e.target.closest('.shot__zoom') ||
                (e.target.matches && e.target.matches('img.shot__img') ? e.target : null);
      if (!hit || !big || typeof zoom.open !== 'function') return;
      var shot = hit.closest('.shot');
      var source = shot && shot.querySelector('img.shot__img');
      if (!source) return;
      e.preventDefault();
      /* currentSrc is whichever srcset candidate the browser already decoded,
         so opening the lightbox costs no second download. */
      big.src = source.currentSrc || source.src;
      big.alt = source.alt || '';
      /* Every open starts contained; magnification is opt-in per view. */
      if (frame) frame.classList.remove('is-magnified');
      zoom.open(hit);
    });

    /* Tap the opened photo to magnify past the viewport, tap again to fit.
       Re-centres on toggle so panning starts from the middle of the shoe
       rather than its top-left corner. */
    if (big && frame) {
      big.addEventListener('click', function () {
        var on = frame.classList.toggle('is-magnified');
        if (!on) return;
        frame.scrollLeft = (frame.scrollWidth - frame.clientWidth) / 2;
        frame.scrollTop = (frame.scrollHeight - frame.clientHeight) / 2;
      });
    }
  })();
  }

  initProduct();
  /* Re-init on a product re-render AND on a header re-render. The latter destroys
     the dock (and the bar inside it) but its event target contains no .product, so
     the old guard alone left the PDP with no buy bar until a full reload.
     initProduct() removes any surviving .buybar first, so this cannot duplicate. */
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !document.querySelector('.product')) return;
    if (e.target.querySelector('.product') || e.target.querySelector('[data-buybar-dock]')) initProduct();
  });
})();
